// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalBiSpendDown {
    static getAttributeTypeMap() {
        return MedicalBiSpendDown.attributeTypeMap;
    }
}
MedicalBiSpendDown.discriminator = undefined;
MedicalBiSpendDown.additionalProperties = false;
MedicalBiSpendDown.attributeTypeMap = [
    {
        "name": "exist",
        "baseName": "exist",
        "type": "boolean"
    },
    {
        "name": "met",
        "baseName": "met",
        "type": "number"
    },
    {
        "name": "total",
        "baseName": "total",
        "type": "number"
    },
];
//# sourceMappingURL=medicalBiSpendDown.js.map